import React from 'react';
import { ChevronDownIcon, SystemIconType } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import { useCollapsibleContext } from '../CollapsibleContext';
import { headerMenuProps } from '../CollapsibleHeaderMenu/helpers';

interface CollapsibleHeaderChevronProps {
  /**
   * Chevron icon size
   */
  size?: SystemIconType['size'];
}

const CollapsibleHeaderChevron = ({ size = 'md' }: CollapsibleHeaderChevronProps) => {
  const { expanded } = useCollapsibleContext();

  return (
    <Container {...headerMenuProps} transition="0.15s" transform={expanded ? 'rotate(-180deg)' : undefined}>
      <ChevronDownIcon size={size} />
    </Container>
  );
};

CollapsibleHeaderChevron.displayName = 'CollapsibleHeaderChevron';
CollapsibleHeaderChevron.id = 'CollapsibleHeaderChevron';
export default CollapsibleHeaderChevron;
